export const ROLE_COLORS = {
  superadmin: 'bg-slate-800 text-white',
  ceo: 'bg-blue-700 text-white',
  people_admin: 'bg-violet-100 text-violet-700',
  sales_manager: 'bg-indigo-100 text-indigo-700',
  recruiting_manager: 'bg-teal-100 text-teal-700',
  onsite_manager: 'bg-orange-100 text-orange-700',
  sales_assistant_manager: 'bg-indigo-50 text-indigo-600',
  recruiting_assistant_manager: 'bg-teal-50 text-teal-600',
  sales_lead: 'bg-blue-100 text-blue-700',
  recruiting_lead: 'bg-cyan-100 text-cyan-700',
  sales_recruiter: 'bg-amber-100 text-amber-700',
  sales_technical_recruiter: 'bg-amber-100 text-purple-700',
  technical_recruiter: 'bg-purple-100 text-purple-700',
};

export function collectNodeIds(nodes = []) {
  const ids = new Set();
  const stack = [...nodes];
  while (stack.length) {
    const node = stack.pop();
    ids.add(node.id);
    stack.push(...(node.children || []));
  }
  return ids;
}

export function filterTreeNodes(nodes = [], predicate) {
  const walk = (node) => {
    const childMatches = (node.children || []).map(walk).filter(Boolean);
    const selfMatch = predicate(node);
    if (selfMatch || childMatches.length > 0) {
      return { ...node, children: childMatches };
    }
    return null;
  };
  return nodes.map(walk).filter(Boolean);
}

export function countUserNodes(nodes = []) {
  let count = 0;
  const stack = [...nodes];
  while (stack.length) {
    const node = stack.pop();
    if (node.nodeType === 'user') count += 1;
    stack.push(...(node.children || []));
  }
  return count;
}
